import { render } from "./header-four.vue?vue&type=template&id=dfc1da3a"
import script from "./header-four.vue?vue&type=script&lang=js"
export * from "./header-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__